import { render, staticRenderFns } from "./sider.vue?vue&type=template&id=2138d4fe&scoped=true&"
import script from "./sider.vue?vue&type=script&lang=js&"
export * from "./sider.vue?vue&type=script&lang=js&"
import style0 from "./sider.vue?vue&type=style&index=0&id=2138d4fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2138d4fe",
  null
  
)

export default component.exports